import React, { useEffect, useState } from 'react';
import { Nav, Container, Form, Button, Row, Col, Card} from 'react-bootstrap';
import { Doughnut } from 'react-chartjs-2';
import "./performance.css";
import { useTheme } from '@mui/material';



const Performance: React.FC = () => {

    let theme = useTheme();
    let color = theme.palette.mode;

    const gaugeData = {
        labels: ["Used", "Free"],
        datasets: [
            {
                data: [20, 80],
                backgroundColor: ["red", "grey", "yellow"],
                hoverBackgroundColor: ["red", "grey","yellow"],
                borderWidth: 0,
            },
        ],
    };

    const gaugeOptions = {
        cutout: "70%",
        rotation: -90,
        circumference: 180,
        plugins: {
            legend: {
                display: true
            },
            tooltip: {
                enabled: true,
            },
        },
    };



    return (
        <Card>
            <h5 className={`${color == 'dark' ? 'header-dark' : ''}`}>Performance</h5>
            <Row style={{marginTop: '8px'}}>
                <Col lg={4} md={4} style={{padding: '12px'}}>
                    <Card text={color==="dark" ? 'white': 'dark'} className='card-size' style={{boxShadow: 'none', gap: '8px', padding: '16px', height: '100%'}}>
                    <span className='same-line header-text'>CPU Utilization</span>
                        <div className='d-flex flex-column align-items-center'>
                            <Doughnut data={gaugeData} options={gaugeOptions} />
                            <span className='bold-text'>100%</span>
                            <span>Processor Queue</span>
                            
                        {/* <div className='d-flex justify-content-between w-100 mt-2 px-4'>
                            <span>0</span>
                            <span>25</span>
                            <span>50</span>
                            <span>75</span>
                            <span>100</span>
                        </div> */}
                        </div>
                    </Card>
                </Col>
                <Col lg={4} md={4} style={{padding: '12px'}}>
                    <Card text={color==="dark" ? 'white': 'dark'} style={{boxShadow: 'none', gap: '8px', padding: '16px', height: '100%'}}>
                        <span className='same-line header-text'>Memory Utilization</span>
                        <div className='d-flex flex-column align-items-center'>
                            <Doughnut data={gaugeData} options={gaugeOptions} />
                            <span className='bold-text'>100%</span>
                            <span>Trans Faults Ration(%)</span>
                            
                        {/* <div className='d-flex justify-content-between w-100 mt-2 px-4'>
                            <span>0</span>
                            <span>25</span>
                            <span>50</span>
                            <span>75</span>
                            <span>100</span>
                        </div> */}
                        </div>
                    </Card>
                </Col>
                <Col lg={4} md={4} style={{padding: '12px'}}>
                    <Card text={color==="dark" ? 'white': 'dark'} style={{boxShadow: 'none', gap: '8px', padding: '16px', height: '100%'}}>
                    <span className='same-line header-text'>Disk Activity</span>
                        <div className='d-flex flex-column align-items-center'>
                            <Doughnut data={gaugeData} options={gaugeOptions} />
                            <span className='bold-text'>100%</span>
                            <span>Free Space(%)</span>
                            
                        {/* <div className='d-flex justify-content-between w-100 mt-2 px-4'>
                            <span>0</span>
                            <span>25</span>
                            <span>50</span>
                            <span>75</span>
                            <span>100</span>
                        </div> */}
                        </div>
                        
                    </Card>
                </Col>
            </Row>
        </Card>
    )
}

export default Performance;